import React from 'react';
import { FaBuilding, FaCheck, FaClock, FaPercentage } from 'react-icons/fa';
import StatCard from './StatCard';

interface StatisticsProps {
  totalProperties: number;
  geocodedCount: number;
  missingCoordinatesCount: number;
  successRate: number;
}

const Statistics: React.FC<StatisticsProps> = ({
  totalProperties,
  geocodedCount,
  missingCoordinatesCount,
  successRate
}) => {
  return (
    <div className="space-y-4">
      <StatCard
        title="Total Properties"
        value={totalProperties}
        icon={FaBuilding}
        color="border-l-blue-500"
        subtitle="All properties in company"
      />
      
      <StatCard
        title="Geocoded"
        value={geocodedCount}
        icon={FaCheck}
        color="border-l-green-500"
        subtitle="Properties with coordinates"
      />
      
      <StatCard
        title="Missing Coordinates"
        value={missingCoordinatesCount}
        icon={FaClock}
        color="border-l-yellow-500"
        subtitle="Properties without coordinates"
        info="Properties that need geocoding to get latitude/longitude"
      />
      
      <StatCard
        title="Success Rate"
        value={`${successRate}%`}
        icon={FaPercentage}
        color="border-l-purple-500"
        subtitle="Geocoding completion rate"
      />
    </div>
  );
};

export default Statistics;
